TareasTiemposDetallesCtrl.$inject = ['$scope', '$http', 'DialogsService'];
export default function TareasTiemposDetallesCtrl($scope, $http, DialogsService) {
    var tarTieDet = this;
    var DATEFROMAT_SERVIDOR = "YYYY-MM-DD HH:mm:ss";
    var DATEFROMAT_WEB = "DD/MM/YYYY HH:mm";
    var tareaId = tarTieDet.modelId;
    var puedeEditar = Sigo.user.puedeEditarTareasTiempos;

    tarTieDet.cargando = true;
    tarTieDet.tareasTiempos = [];
    tarTieDet.puedeEditar = puedeEditar;

    tarTieDet.actualizar = actualizar;
    $scope.actualizar = actualizar;

    tarTieDet.actualizar();

    tarTieDet.duracionEnSegudosAString = function (duracionEnSegundos) {
        var duracion = moment.duration(duracionEnSegundos, 'seconds');

        var strDuracion = '';

        if (duracion.years() > 0) strDuracion += duracion.years() + " " + Lang.choice("nombres.anyo", duracion.years()) + " ";
        if (duracion.months() > 0) strDuracion += duracion.months() + " " + Lang.choice("nombres.mes", duracion.months()) + " ";
        if (duracion.days() > 0) strDuracion += duracion.days() + "d ";
        if (duracion.hours() > 0) strDuracion += duracion.hours() + "h ";
        if (duracion.minutes() > 0) strDuracion += duracion.minutes() + "m ";
        if (duracion.seconds() > 0) strDuracion += duracion.seconds() + " s";

        return strDuracion;
    };

    tarTieDet.actualizarTiempo = function (tareaTiempo, atributo) {
        if (!puedeEditar) return;
        var fechaFecha = moment(tareaTiempo[atributo], DATEFROMAT_SERVIDOR);

        var opciones = {
            id: 'tareaTiempoEditFecha',
            titulo: ucfirst(Lang.get('nombres.editar')) + " " + Lang.choice('nombres.tiempo', 1),
            label: ucfirst(Lang.choice('nombres.tiempo', 1)),
            modelo: fechaFecha.format(DATEFROMAT_WEB),
            callbackSubmit: function (fecha) {
                var fechaParaServidor = moment(fecha, DATEFROMAT_WEB).format(DATEFROMAT_SERVIDOR);

                return actualizarFechaTiempo(tareaTiempo.id, atributo, fechaParaServidor);
            }
        };
        return DialogsService.date(opciones);
    };


    function actualizar() {
        tarTieDet.cargando = true;

        var promise = $http.get('/api/v1/tareas/' + tareaId + '/tiempos');
        promise.then(function (respuesta) {
            tarTieDet.tareasTiempos = respuesta.data;
            tarTieDet.cargando = false;
        });
        return promise;
    }

    function actualizarFechaTiempo(tareaTiempoId, atributo, fechaTiempo) {
        var data = {};
        data[atributo] = fechaTiempo;
        var promesa = $http.post('/api/v1/tareas-tiempos/' + tareaTiempoId, data);

        promesa.then(function () {
            Sigo.UI.Toast.success('', "mensajes.guardado_exito");
            actualizar();
        }, function (err) {
            Sigo.UI.Messages.open(['mensajes.error_mensaje'], 0);
        });
        return promesa;
    }
}